import React from "react";
import Views from "@views";
import AdminProtectedRoute from "components/AdminProtectedRoute";
import InnoIcons from "@InnoIcons/";

const adminDrawer = [
  {
    text: "Users",
    route: "/admin-settings/users",
    icon: <InnoIcons.PersonRoundedIcon />,
    element: <AdminProtectedRoute element={<Views.Users />} />,
  },
  {
    text: "Roles & Permissions",
    route: "/admin-settings/roles-permission",
    icon: <InnoIcons.LockIcon />,
    element: <AdminProtectedRoute element={<Views.RolesandPermission />} />,
  },
  {
    text: "Folder Template",
    route: "/admin-settings/folder-template",
    icon: <InnoIcons.CreateNewFolderOutlinedIcon />,
    element: <AdminProtectedRoute element={<Views.FolderTemplate />} />,
  },
  {
    text: "Projects",
    route: "/admin-settings/projects",
    icon: <InnoIcons.FolderIcon />,
    element: <AdminProtectedRoute element={<Views.Projects />} />,
  },
  {
    text: "Companies",
    route: "/admin-settings/companies",
    icon: <InnoIcons.AccountBalanceIcon />,
    element: <AdminProtectedRoute element={<Views.Companies />} />,
  },
  {
    text: "Holidays",
    route: "/admin-settings/holidays",
    icon: <InnoIcons.CalendarMonthIcon />,
    element: <AdminProtectedRoute element={<Views.Holidays />} />,
  },
  {
    text: "System Prompts",
    route: "/admin-settings/system-prompts",
    icon: <InnoIcons.AutoAwesomeIcon />,
    element: <AdminProtectedRoute element={<Views.SystemPrompts />} />,
  },
];

const privateRoutes = {
  adminDrawer,
};

export default privateRoutes;
